import { useState } from "react";

const useAudioPermission = (audioFilePath) => {
  const [isAllowed, setIsAllowed] = useState(false);
  const [audio] = useState(new Audio(audioFilePath));

  const requestPermissionAndPlay = () => {
    setIsAllowed(true);

    // Play audio only when the user interacts (click/tap)
    const playPromise = audio.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => console.log(""))
        .catch((error) => console.log("Autoplay blocked:", error));
    }
  };

  return { requestPermissionAndPlay, isAllowed };
};

export default useAudioPermission;
